<template>
  <v-container fluid class="pt-0">
    <v-row>
      <v-col
        cols="12"
        sm="10"
        md="6"
        lg="8"
        class="pa-0 d-flex justify-center align-center flex-column"
        :style="
          $vuetify.breakpoint.mdAndUp
            ? 'background-color: #4777bb;  height: 80vh;'
            : 'background-color: #4777bb;  height: 100vh;'
        "
      >
        <h1
          class="white--text text-center px-12"
          v-if="$vuetify.breakpoint.mdAndUp"
        >
          ¿En qué consiste el diplomado en Gestión <br />
          y Logística de Comercio Exterior (GCE)?
        </h1>
        <h1 class="white--text text-center px-10" v-else>
          Diplomado en Gestión y Logística de Comercio Exterior (GCE)
        </h1>
        <br />
        <br />
        <v-container class="text-justify mx-12 white--text">
          <h4 class="px-10">
            El objetivo de este diplomado es que seas capaz de presentar un
            proyecto para la gestión integral del proceso logístico asociado a
            procesos de exportación, describiendo el detalle de cada una de las
            operaciones requeridas según un producto específico, aplicando
            técnicas y metodologías de control de calidad para hacerlo
            eficientes y cumplir con los objetivos de un negocio que es
            maximizar las ganancias.
          </h4>
        </v-container>
        <v-btn
          @click="$router.push('/diplomado')"
          rounded
          class="link-button-animated grey--text text--darken-4 mt-2"
        >
          ¡Quiero informes!
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        sm="10"
        md="6"
        lg="4"
        class="pa-0"
        v-if="$vuetify.breakpoint.mdAndUp"
      >
        <v-img
          src="/diplomados/Comercio2.jpg"
          height="80vh"
          width="100%"
        ></v-img>
      </v-col>
    </v-row>

    <!-- Seccion de temario-->
    <v-row>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
        <v-card width="400">
          <v-card-text>
            <h2 class="font-weight-bold ml-8 mb-2">
              Temario
              <br />
            </h2>
            <p class="ml-8 mb-2">
              En este diplomado se revisarán tres bloques temáticos:
            </p>
            <v-timeline align-top dense>
              <v-timeline-item
                v-for="message in messages"
                :key="message.time"
                :color="message.color"
                small
              >
                <div>
                  <div class="font-weight-normal">
                    <strong
                      ><span class="primary--text">{{ message.from }}</span>
                      {{ message.message }}
                    </strong>
                  </div>
                </div>
              </v-timeline-item>
            </v-timeline>
            <div class="ml-8 mb-2">
              <br />
              <p>
                El abordaje se hace a partir de la integración sistémica del
                proceso de comercio exterior.
              </p>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 8 : 12">
        <v-card color="#4d6fa0" dark>
          <v-card-text>
            <div class="ml-8 mb-2">
              <h2>
                En cada bloque temático te encontrarás con:
                <br />
                <br />
              </h2>
              <ul>
                <li>Temáticas por revisar</li>
                <li>Actividad Entregable</li>
              </ul>
              <v-divider class="test mt-5 mb-5"></v-divider>
              <p>
                La propuesta de estudio es leer todo el material y utilizar
                estrategias de aprendizaje. <br />Al final construirás tus
                entregables, con las especificaciones que te señalen.
              </p>
              <v-divider class="test mt-5 mb-5"></v-divider>
              <p>
                Estas evidencias serán parte indispensable de tu proyecto
                integrador. Lo anterior implica que:
              </p>
              <br />
              <h2>Seas un estudiante autorregulado y autodirigido</h2>
              <br />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="10" md="5" lg="5" class="pa-0">
        <v-img
          src="/diplomados/Comercio3.png"
          :height="$vuetify.breakpoint.mdAndUp ? '90vh' : '120vh'"
          width="100%"
        ></v-img>
      </v-col>
      <v-col
        cols="12"
        sm="10"
        md="7"
        lg="7"
        class="pa-0 d-flex justify-center align-center flex-column"
        :style="
          $vuetify.breakpoint.mdAndUp
            ? 'background-color: #4777bb;  height: 90vh;'
            : 'background-color: #4777bb;  height: 120vh;'
        "
      >
        <h1
          class="white--text text-center mx-10"
          style="color: rgba(255, 255, 255, 0.7) !important"
        >
          ¿Cómo acreditar el diplomado?
        </h1>
        <br />
        <h4 class="text-justify mx-10 white--text">
          Para fines de acreditación del diplomado, será necesario haber
          presentado todas las evidencias correspondientes según los bloques
          temáticos. Deberás demostrar un nivel de suficiencia en la aplicación
          de los conceptos implicados, según los requisitos dispuestos en
          términos de evaluación del aprendizaje, para la correcta realización
          del proyecto final.
        </h4>
        <br />
        <h4 class="text-justify mx-10 grey--text font-weight-light">
          *Cualquier evidencia de plagio será sancionado con la no acreditación.
        </h4>
        <br />
        <h4 class="text-justify mx-10 grey--text font-weight-light">
          *Los exámenes son sólo diagnósticos para identificar qué necesitas
          aprender y no son parte de la evaluación del diplomado.
        </h4>
        <v-btn
          @click="$router.push('/diplomado')"
          rounded
          class="link-button-animated grey--text text--darken-4 mt-2"
        >
          ¡Quiero informes!
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        :cols="$vuetify.breakpoint.mdAndUp ? 5 : 12"
        :class="
          $vuetify.breakpoint.mdAndUp
            ? 'px-6 py-6 d-flex justify-center align-center flex-column dark'
            : 'px-6 py-6 d-flex justify-center align-center flex-column dark  mt-5'
        "
        :style="
          $vuetify.breakpoint.mdAndUp
            ? 'background-color: #4777bb;  height: 110vh;'
            : 'background-color: #4777bb;  height: 170vh;'
        "
      >
        <br />
        <!-- <img
          src="/diplomados/ultimos.png"
          style="width: 22rem; padding-bottom: 5%"
        /> -->
        <h3
          class="text-justify white--text mb-5"
          style="color: rgba(255, 255, 255, 0.7) !important"
        >
          Fecha de inicio
        </h3>
        <h4 class="white--text">17 de Febrero 2025</h4>
        <h4 class="white--text">16 de Junio 2025</h4>
        <h4 class="white--text">17 de Noviembre 2025</h4>
        <h4 class="white--text">*Cupos Limitados</h4>
        <br />
        <h5 class="text-justify grey--text font-weight-light">
          *Duración de 4 meses
        </h5>
        <v-divider class="test mt-5 mb-5"></v-divider>

        <h3
          class="white--text mb-5"
          style="color: rgba(255, 255, 255, 0.7) !important"
        >
          Documentos para inscripción
        </h3>
        <ul class="white--text">
          <li><h4 class="white--text">Acta de nacimiento.</h4></li>
          <li><h4 class="white--text">CURP.</h4></li>
          <li><h4 class="white--text">Correo electrónico.</h4></li>
          <li><h4 class="white--text">Domicilio completo.</h4></li>
          <li><h4 class="white--text">Número de celular o teléfono.</h4></li>
          <li>
            <h4 class="white--text">
              Licenciatura terminada, universidad procedente o campus de egreso.
            </h4>
          </li>
          <li>
            <h4 class="white--text">
              Diplomado elegido, fecha de inicio del diplomado de su elección.
            </h4>
          </li>
          <li>
            <h4 class="white--text">
              Entrega de carta de autorización, carta de no adeudo académico y
              de finanzas.
            </h4>
            <h5 class="white--text font-weight-light">
              (con una antigüedad no mayor a 15 días naturales). <br />Solo
              alumnos de licenciatura de Vizcaya.
            </h5>
          </li>
        </ul>
        <v-divider class="test mt-5 mb-5"></v-divider>
        <h3
          class="text-justify white--text mb-5"
          style="color: rgba(255, 255, 255, 0.7) !important"
        >
          Realiza la inversión
        </h3>
        <h4 class="white--text">Costo total del Diplomado: $15,000</h4>
        <v-btn
          @click="$router.push('/diplomado')"
          rounded
          class="link-button-animated grey--text text--darken-4 mt-2"
        >
          ¡Quiero informes!
        </v-btn>
        <br />
      </v-col>

      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 7 : 12" class="pa-0">
        <v-img
          src="/diplomados/Comercio1.jpg"
          height="110vh"
          width="100%"
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.ligthBlue {
  background-color: #84a4d1;
}
.ligthBlueText {
  color: #84a4d1;
}
.ext-container {
  background-image: url("/images/imagenes/campo-accion.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 5;
}
.test {
  border-width: 1px !important;
  border-color: white !important;
  width: 100%;
}
.containerMovil {
  background-color: #4777bb;
  height: 140vh;
}
</style>
<script>
import { mapState } from "vuex";
import _ from "lodash";

export default {
  components: {},
  mounted() {},
  data: () => ({
    messages: [
      {
        from: "1. ",
        message: `Logística y distribución`,
        color: "amber",
      },
      {
        from: "2. ",
        message: "INCOTERMS",
        color: "orange",
      },
      {
        from: "3. ",
        message: "Calidad",
        color: "orange darken-4",
      },
    ],
  }),
  computed: {
    ...mapState({}),
  },
  methods: {},
  watch: {},
};
</script>
